import appointmentMixinBase from '@satellite/components/mixins/appointmentMixinBase';

/**
 * Mixin used for appointments
 * @mixin
 * @displayName Appointment Mixin
 */
export default {
  computed: {
    ...appointmentMixinBase.computed
  },
  data() {
    return {
      ...appointmentMixinBase.data()
    };
  },
  methods: {
    ...appointmentMixinBase.methods
  }
};
